import { render } from "./DeleteReservation.vue?vue&type=template&id=3844ca32&scoped=true&ts=true"
import script from "./DeleteReservation.vue?vue&type=script&lang=ts"
export * from "./DeleteReservation.vue?vue&type=script&lang=ts"

import "./DeleteReservation.vue?vue&type=style&index=0&id=3844ca32&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3844ca32"]])

export default __exports__